import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbValidators} from "../../../../../shared/validators/DbValidators";
import {OptionRegion} from "../../../../../shared/models/option-region.model";
import {UserSubscription, UserSubscriptionCategory} from "../../../../../user/user-subscription";

@Component({
    selector: 'db-create-website-trial-install',
    templateUrl: './create-website-trial-install.component.html',
    styleUrls: ['./create-website-trial-install.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CreateWebsiteTrialInstallComponent implements OnInit {

  @Input() companyName: string;
  @Input() regions: OptionRegion[] = [];
  @Input() hostedWebsitesCount = 0;
  @Input() hostedWebsitesLimit = 0;
  @Input() userSubscription: UserSubscription;
  @Output() submitted = new EventEmitter<{ region: string, siteTitle: string }>();
  public formSubmitted = false;
  public createWebsiteForm = new FormGroup({
    websiteTitle: new FormControl('My Website', [DbValidators.trimStart, Validators.required]),
    region: new FormControl(null, Validators.required),
  });
  public  UserSubscriptionCategory = UserSubscriptionCategory;
  constructor() { }

  ngOnInit() {
    this._setRegion();
  }

  private _setRegion(): void {
    const availableRegion = this.regions.find(region => region.isAvailable);
    if (availableRegion) {
      this.createWebsiteForm.get('region').setValue(availableRegion.value);
    }
  }

  submit(): void {
    this.formSubmitted = true;
    if (this.createWebsiteForm.invalid) return;

    const websiteData = {region: this.createWebsiteForm.value.region, siteTitle: this.createWebsiteForm.value.websiteTitle};
    this.submitted.emit(websiteData);
  }
}
